import keys from '@debbie/common/dist/cache/keys.js';
import { InternationalTribunalJobType, } from '@debbie/common/dist/tribunal/jobs/types.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../../../utils/errors.js';
import NewEditor from '../../../editor/Editor.js';
import { useEditorState } from '../../../editor/hooks.js';
import { Button } from '../../../index.js';
const CreateNote = (props) => {
    const lang = useSelector((s) => s.lang);
    const editorState = useEditorState();
    const createNoteMutation = useMutation(async () => {
        await tribunalAPI.createTribunalJob({
            type: InternationalTribunalJobType.Note,
            tribunalCaseId: props.tribunalCase.id,
            data: {
                note: editorState.html,
            },
            caseId: props.tribunalCase.caseId,
        });
        q.invalidate(keys.write.create(tribunalJobsEntity));
        props.onSubmit();
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.tribunalJob);
        },
    });
    return (React.createElement("div", null,
        React.createElement(NewEditor, { mentions: [], onChange: editorState.onChange, initialContent: editorState.editorContent }),
        React.createElement(Button, { onClick: () => createNoteMutation.mutate(), loading: createNoteMutation.isLoading, block: true }, lang.tribunal.createTribunalCase)));
};
export default CreateNote;
//# sourceMappingURL=CreateNote.js.map